// Ensure all <img> elements inside a container are fully loaded
export async function waitForImages(container) {
  const imgs = Array.from(container.querySelectorAll("img"));
  if (!imgs.length) return;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  // Force a reflow on iOS to ensure images are rendered
  if (isIOS) {
    container.style.transform = 'translateZ(0)';
    void container.offsetHeight; // trigger reflow
  }

  await Promise.all(
    imgs.map((img) => {
      if (img.complete && img.naturalWidth > 0) {
        return Promise.resolve();
      }

      return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error(`Image load timeout: ${img.src}`));
        }, 10000);

        img.onload = () => {
          clearTimeout(timeout);
          resolve();
        };

        img.onerror = () => {
          clearTimeout(timeout);
          reject(new Error(`Image failed to load: ${img.src}`));
        };

        // iOS hack: force reload if marked complete but has no dimensions
        if (img.complete && img.naturalWidth === 0) {
          const src = img.src;
          img.src = '';
          img.src = src;
        }
      });
    })
  );
}
